<template>
  <NavbarLayout />
  <SidebarLayout v-if="userData != null" />
  <v-main id="content">
    <div class="relative w-100 min-vh-100 flex justify-start items-center">
      <!-- Video Background -->
      <video ref="videoRef" class="absolute top-0 left-0 w-full h-full object-cover" loop playsinline autoplay>
        <source
          src="https://sinisaja.borneo-indobara.com/cms/view/BIB%20Journey_Profile_Ethnic_Dubber%20Indonesia_Nina_28110.mp4"
          type="video/mp4" />
      </video>
      <div class="absolute top-0 left-0 w-full h-full bg-gradient-to-b from-white/20 to-black/75"></div>
      <v-container class="relative z-10 gap-5 text-white">
        <h1 class="font-inter font-bold text-7xl">PT Borneo Indobara</h1>
        <p class="text-base font-inter">
          PT Borneo Indobara merupakan perusahaan pertambangan batubara dengan
          perizinan Perjanjian Karya Pengusahaan Pertambangan Batubara (PKP2B)
          Generasi Kedua dengan masa berlaku hingga tahun 2036. PT Borneo
          Indobara berlokasi di Kecamatan Angsana, Kabupaten Tanah Bumbu,
          Kalimantan Selatan dengan luas konsesi sebesar 24.100 Ha.
        </p>
      </v-container>
    </div>
    <v-container>
      <v-row class="mt-10">
        <v-col cols="12">
          <h2 class="text-4xl font-semibold text-black border-t-[3px] w-fit border-t-red-600 pt-3">
            Sejarah Kami
          </h2>
        </v-col>

        <v-col cols="8">
          <p class="text-base text-black font-normal text-wrap mt-2">
            PT Borneo Indobara merupakan perusahan pertambangan batubara dengan
            perizinan Perjanjian Karya Pengusahaan Pertambangan Batubara (PKP2B)
            Generasi Kedua dengan masa berlaku hingga tahun 2036. PT Borneo
            Indobara berlokasi di Kecamatan Angsana, Kabupaten Tanah Bumbu,
            Kalimantan Selatan dengan luas konsesi sebesar 24.100 Ha.
          </p>
        </v-col>
        <v-col cols="4" class="flex justify-end">
          <img class="w-4/5" src="../assets/images/tentang_bib_2.png" alt="" />
        </v-col>
        <v-col cols="12">
          <p class="text-base text-black font-normal text-wrap mt-2">
            PT Borneo Indobara merupakan perusahaan pertambangan batubara dengan
            perizinan Perjanjian Karya Pengusahaan Pertambangan Batubara (PKP2B)
            Generasi Kedua dengan masa berlaku hingga tahun 2036. PT Borneo
            Indobara berlokasi di Kecamatan Angsana, Kabupaten Tanah Bumbu,
            Kalimantan Selatan dengan luas konsesi sebesar 24.100 Ha.
          </p>
          <img class="img-fluid" src="../assets/images/tentang_bib_grafik_new.png" alt="" />
        </v-col>
        <v-col cols="12" class="mt-10">
          <h2 class="text-4xl font-semibold text-black border-t-[3px] w-fit border-t-red-600 pt-3">
            Informasi Umum
          </h2>
        </v-col>
        <v-col cols="12">
          <div class="flex justify-between items-start">
            <div class="flex flex-col gap-16">
              <div class="flex gap-3 items-center justify-start">
                <img class="w-14 h-auto" src="../assets/images/capaian_1.png" />
                <div class="flex flex-col gap-2">
                  <h6 class="font-semibold">Produk Batubara</h6>
                  <p>Kalori Batubara = 4000 – 4200 Kcal / Kg</p>
                </div>
              </div>
              <div class="flex gap-3 items-center justify-start">
                <img class="w-14 h-auto" src="../assets/images/capaian_2.png" />
                <div class="flex flex-col gap-2">
                  <h6 class="font-semibold">Perizinan</h6>
                  <p>PKP2B Gen 2 (2006 – 2036)</p>
                </div>
              </div>
              <div class="flex gap-3 items-center justify-start">
                <img class="w-14 h-auto" src="../assets/images/capaian_3.png" />
                <div class="flex flex-col gap-2">
                  <h6 class="font-semibold">Luas Konsensi</h6>
                  <p>24,100 Ha</p>
                </div>
              </div>
            </div>
            <img class="w-2/4 h-auto" src="../assets/images/tentang_bib_3.png" />
          </div>
        </v-col>
        <v-col col="12" class="mt-10">
          <h2 class="text-4xl font-semibold text-black border-t-[3px] w-fit border-t-red-600 pt-3">
            Nilai Perusahaan
          </h2>
        </v-col>
        <v-col cols="12">
          <v-row>
            <v-col cols="4">
              <div class="flex flex-col gap-2">
                <div class="gap-2 flex justify-start items-end">
                  <span class="w-7 h-auto font-normal text-3xl text-red-700">
                    ✓
                  </span>
                  <h6 class="text-base">Integrasi</h6>
                </div>
                <p class="text-base">
                  Bertindak sesuai ucapan/janji sehingga dapat menumbuhkan
                  kepercayaan pihak lain
                </p>
              </div>
            </v-col>
            <v-col cols="4">
              <div class="flex flex-col gap-2">
                <div class="gap-2 flex justify-start items-end">
                  <span class="w-7 h-auto font-normal text-3xl text-red-700">
                    ✓
                  </span>
                  <h6 class="text-base">Sikap Positif</h6>
                </div>
                <p class="text-base">
                  Menampilkan perilaku yang mendukung terciptanya lingkungan
                  kerja yang saling menghargai dan kondusif
                </p>
              </div>
            </v-col>
            <v-col cols="4">
              <div class="flex flex-col gap-2">
                <div class="gap-2 flex justify-start items-end">
                  <span class="w-7 h-auto font-normal text-3xl text-red-700">
                    ✓
                  </span>
                  <h6 class="text-base">Komitmen</h6>
                </div>
                <p class="text-base">
                  Melaksanakan pekerjaan dengan sepenuh hati untuk mencapai
                  hasil terbaik
                </p>
              </div>
            </v-col>
            <v-col cols="4">
              <div class="flex flex-col gap-2">
                <div class="gap-2 flex justify-start items-end">
                  <span class="w-7 h-auto font-normal text-3xl text-red-700">
                    ✓
                  </span>
                  <h6 class="text-base">Perbaikan Berkelanjutan</h6>
                </div>
                <p class="text-base">
                  Meningkatkan kemampuan atau kapasitas diri, unit kerja, dan
                  orginasasi secra terus menerus tanpa batas untuk mencapai
                  hasil terbaik
                </p>
              </div>
            </v-col>
            <v-col cols="4">
              <div class="flex flex-col gap-2">
                <div class="gap-2 flex justify-start items-end">
                  <span class="w-7 h-auto font-normal text-3xl text-red-700">
                    ✓
                  </span>
                  <h6 class="text-base">Inovasi</h6>
                </div>
                <p class="text-base">
                  Memunculkan gagasan atau menciptakan produk/alat kerja/sistem
                  kerja baru yang dapat meningkatkan produktivitas dan
                  pertumbuhan perusahaan
                </p>
              </div>
            </v-col>
            <v-col cols="4">
              <div class="flex flex-col gap-2">
                <div class="gap-2 flex justify-start items-end">
                  <span class="w-7 h-auto font-normal text-3xl text-red-700">
                    ✓
                  </span>
                  <h6 class="text-base">Loyal</h6>
                </div>
                <p class="text-base">
                  Menumbuhkembangkan semangat untuk mengerti, memahami, dan
                  melaksanakan nilai-nilai perusahaan sebagai bagian dari Grup
                  Sinar Mas
                </p>
              </div>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" class="mt-10">
          <h2 class="text-4xl font-semibold text-black border-t-[3px] w-fit border-t-red-600 pt-3">
            Visi Perusahaan
          </h2>

          <div class="flex flex-wrap leading-relaxed mt-10 text-justify text-xl w-full">
            <span class="text-5xl text-red-400 font-inter self-start mr-1 leading-4">
              “
            </span>

            <p class="flex-1">
              Menjadi perusahaan tambang terkemuka di Indonesia dengan
              penciptaan nilai tambah bagi pelanggan dan semua pemangku
              kepentingan
              <span class="ml-1 text-5xl text-red-400 font-inter relative top-2">
                ”
              </span>
            </p>
          </div>
        </v-col>
        <v-col cols="12" class="mt-10">
          <v-row>
            <v-col cols="6">
              <img src="../assets/images/tentang_bib_4.png" alt="" class="w-4/5 h-auto float-start" />
            </v-col>
            <v-col cols="6">
              <h2 class="text-4xl font-semibold text-black border-t-[3px] w-fit border-t-red-600 pt-3">
                Misi Perusahaan
              </h2>
              <p class="text-base mt-3">
                Misi membangun budaya korporasi yang berpusat pada pengelolaan
                aset sumber daya manusia, fokus pada operasional yang unggul dan
                terus bertumbuh melalui penerapan standar keselamatan, kesehatan
                kerja dan keselamatan operasional serta penerapan
                prinsip-prinsip Environmental, Social, and Governance (ESG)
                yaitu pengelolaan dan perlindungan lingkungan hidup, penguatan
                hubungan eksternal, pemberdayaan masyarakat secara berkelanjutan
                dan proses perbaikan berkelanjutan di internal perusahaan.
              </p>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>
<style scoped>
#container {
  background: #ffffff url("@/assets/images/bg-right.png") no-repeat;
  background-position: left -1rem top 45rem;
}
</style>
<script>
import SidebarLayout from "@/layouts/SidebarLayout.vue";
import GlobalDataMixin from "../GlobalDataMixin";
import NavbarLayout from "@/layouts/NavbarLayout.vue";

export default {
  mixins: [GlobalDataMixin],
  name: "TentangBIB",
  metaInfo() {
    return {
      title: "Home",
    };
  },
  components: { SidebarLayout, NavbarLayout },
  mounted() {
    this.setupVideoObserver();
    this.enableSoundAfterInteraction();
  },

  methods: {
    setupVideoObserver() {
      const video = this.$refs.videoRef;
      if (!video) return;
      video
        .play()
        .catch((error) => console.warn("Autoplay gagal:", error));

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              video.play().catch((error) => console.warn("Play gagal:", error));
            } else {
              video.pause();
            }
          });
        },
        { threshold: 0.5 }
      );

      observer.observe(video);
      this.observer = observer;
    },

    enableSoundAfterInteraction() {
      const video = this.$refs.videoRef;
      if (!video) return;

      const userInteractionHandler = () => {
        video.muted = false;
        video.play().catch((error) => console.warn("Manual play gagal:", error));

        document.removeEventListener("click", userInteractionHandler);
        document.removeEventListener("scroll", userInteractionHandler);
      };

      document.addEventListener("click", userInteractionHandler);
      document.addEventListener("scroll", userInteractionHandler);
    }
  },
  beforeUnmount() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
};
</script>
